import * as tslib_1 from "tslib";
import { EntityQuery, FetchStrategy, QueryOptions } from 'breeze-client';
import * as moment from 'moment';
import { OverlayProvider } from '../../ui/overlay-provider';
import { LocalisationService } from '../../core/localisation.service';
import { OverlayService } from '../../core/overlay.service';
import { DomainService } from '../../domain.service';
import { AlertsService } from '../../core/alerts.service';
import { ResourceService } from '../../resource.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
var AcceptServiceComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AcceptServiceComponent, _super);
    /**
     * Creates an instance of AcceptServiceComponent.
     * @param {ActivatedRoute} route The route contains the entity key
     * @param {DomainService} domainService The domain service is used to retrieve the entity
     */
    function AcceptServiceComponent(overlayProvider, resourceService, overlayService, localisationService, domainService, alertsService) {
        var _this = _super.call(this) || this;
        _this.resourceService = resourceService;
        _this.overlayService = overlayService;
        _this.localisationService = localisationService;
        _this.domainService = domainService;
        _this.alertsService = alertsService;
        /** Indicates whether the attendant's period is shorter than its service */
        _this.deviatingTimes = false;
        _this.entity = overlayProvider.entity;
        var query = EntityQuery.from('AttendantsOfService').expand('Resource');
        query.parameters = { oid: _this.entity['Oid'] };
        query.queryOptions = new QueryOptions({ fetchStrategy: FetchStrategy.FromServer });
        _this.domainService.entityManager.executeQuery(query).then(function (response) {
            // Detach attendants that do not exist any more.
            var attendants = _this.entity['Attendants'];
            if (attendants) {
                var i = attendants.length;
                var _loop_1 = function () {
                    // Remove deleted attendants from cache.
                    var item = attendants[--i];
                    if (!response.results.some(function (entity) { return item['Oid'] === entity['Oid']; })) {
                        attendants.splice(i, 1);
                        item.entityAspect.setDetached();
                    }
                };
                while (i > 0) {
                    _loop_1();
                }
            }
            _this.attendant = response.results.find(function (a) { return !a['Resource'] &&
                a['Start'].getTime() === _this.entity['StartBase'].getTime() && a['Finish'].getTime() === _this.entity['FinishBase'].getTime(); });
            // #3951: Eerst meldden we alleen kortere werktijden, maar sinds FIXED/FLOAT services alle afwijkingen
            _this.deviatingTimes = !_this.attendant;
            if (!_this.attendant) {
                _this.attendant = response.results.find(function (a) { return !a['Resource']; });
            }
            if (!_this.attendant) {
                _this.alertsService.createAlert('warning', 'APP.MARKETPLACE.SERVICE.TAKEN');
                _this.overlayService.closeOverlay();
            }
        });
        return _this;
    }
    /**
     * Returns a string representation of the date component of the parameter
     * @param {Date} date The date to be displayed
     * @returns The date in localised string format
     */
    AcceptServiceComponent.prototype.dateFormat = function (date) {
        return moment(date).format(this.localisationService.date.format);
    };
    /**
     * Returns a string representation of the time component of the parameter
     * @param {Date} date The date whose time is displayed
     * @returns The time in localised string format
     */
    AcceptServiceComponent.prototype.timeFormat = function (date) {
        return moment(date).format(this.localisationService.time.format);
    };
    /**
     * Attaches the user's resource to an unassigned attendant
     * @param {any} event The button that is pressed
     */
    AcceptServiceComponent.prototype.accept = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var attendant;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (event) {
                            event.target.classList.add('sym-working');
                        }
                        return [4 /*yield*/, this.domainService.getEntityByKey(this.attendant.entityType, this.attendant['Oid'], false).toPromise()];
                    case 1:
                        attendant = _a.sent();
                        if (!attendant['Resource_Oid']) {
                            attendant['Resource_Oid'] = this.resourceService.getResourceOid();
                            this.domainService.saveChanges(function (error) {
                                if (error) {
                                    _this.alertsService.createAlert('warning', 'APP.MARKETPLACE.SERVICE.NOT_ACCEPTED');
                                }
                                else {
                                    _this.alertsService.createAlert('success', 'APP.MARKETPLACE.SERVICE.ACCEPTED');
                                }
                                _this.overlayService.closeOverlay();
                            });
                        }
                        else {
                            this.alertsService.createAlert('warning', 'APP.MARKETPLACE.SERVICE.TAKEN');
                            this.overlayService.closeOverlay();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Closes the overlay without saving
     */
    AcceptServiceComponent.prototype.cancel = function () {
        this.overlayService.closeOverlay();
    };
    return AcceptServiceComponent;
}(AbstractBase));
export { AcceptServiceComponent };
